/* tickBoxWrapper-compiled.tsx generated by @compiled/babel-plugin v0.38.1 */
import "./tickBoxWrapper-compiled.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { fg } from '@atlaskit/platform-feature-flags';
import { tickBoxClassName } from './styles';
import { B200 } from '@atlaskit/theme/colors';
var selectedStyles = null;
var oldWrapperStyes = null;
var wrapperStyles = null;
export var TickBoxWrapper = function TickBoxWrapper(props) {
  return /*#__PURE__*/React.createElement("div", {
    id: "tickBoxWrapper",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    className: ax(["_11c82smr _2rkov47k _4cvr1h6o _6a6z1h6o _v564ybtr _1bsbpxbi _4t3ipxbi _kqswstnw _154i1tpr _1ltv1tpr _syaz1j28 _1e0c11p5 _1b941ule", !fg('platform-visual-refresh-icons') && "_1bsbdlk8 _4t3idlk8 _1mcmdlk8", props.selected && "_bfhkqre5 _syaz5w2r", tickBoxClassName]),
    style: {
      "--_1flhvp0": ix("var(--ds-icon-information, ".concat(B200, ")"))
    }
  }, props.children);
};
TickBoxWrapper.displayName = 'TickBoxWrapper';